import { Status } from "../../models/Status";

export const LEADER_BOARD_STATUS = "LEADER_BOARD_STATUS";
export const LEADER_BOARD_DATA = "LEADER_BOARD_DATA";

export type IState = {
  status: Status;
  data: Record<string, unknown>[];
};
